import PropTypes from 'prop-types';

import { ContemporaryLandingFeaturedRowItem } from './ContemporaryLandingFeaturedRowItem';

export const ContemporaryLandingFeaturedRow = ({ items, rowIndex }) => {
    if (!items || !items.length) {
        return null;
    }

    return (
        <div className="rowFlex">
            {items.map((item, index) => (
                <ContemporaryLandingFeaturedRowItem
                    key={`${item.title}-${index}`}
                    item={item}
                    rowIndex={rowIndex}
                />
            ))}
        </div>
    );
};

ContemporaryLandingFeaturedRow.propTypes = {
    items: PropTypes.array,
    rowIndex: PropTypes.number.isRequired,
};
